import { t } from "@lingui/macro";

/**
 * Toast shown when the server could only read the first part of a long CV
 * (`truncated` on the parse result), so a missing later role is never a
 * mystery. Shared by the onboarding wizard and the dashboard import dialog.
 */
export const truncatedParseToast = () => ({
  variant: "warning" as const,
  title: t`We could only read the first part of your CV`,
  description: t`Check your later roles and add anything that's missing.`,
});
